<template>

    <transition name="fade">


        <div class="overlay transparent" v-if="popupShown">

            <div class="modal popup">

                <span class="popup-close" @click="closePopup()">&times;</span>

                <header class="modal-header">
                    <h3>Mit Zissel auf der Gewinnerseite!</h3>

                </header>

                <div class="modal-content">
                    <a @click="closePopupAndRedirect()" class="btn">
                        <span>Hier geht’s zum<br>
                            Bayron-Man 2010-Gewinnspiel!</span>
                    </a>

                </div>

            </div>

        </div>



    </transition>



</template>


<script>
import { mapGetters } from 'vuex'
import store from '../../store'

export default {

    computed: mapGetters([ 'popupShown', 'ageConfirmed' ]),

    data() {
        return {

        }
    },


    watch: {

        ageConfirmed() {
            setTimeout(() => store.dispatch('openPopup'), 4000);

            setTimeout(() => store.dispatch('closePopup'), 15000);

        },

        popupShown() {
            this.$nextTick(() => {
                document.body.addEventListener('click', () => store.dispatch('closePopup'))
                document.querySelector('.popup').addEventListener('click', e => e.stopPropagation())
            })
        }


    },


    methods: {

        closePopup() {
            store.dispatch('closePopup')
        },

        closePopupAndRedirect() {
            this.closePopup()
            this.$router.push('/gewinnspiel')
        }

    }



}

</script>



// WEBPACK FOOTER //
// popup-game.vue?60ee1af1